export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const FIRST_AUTH_DATA = 'FIRST_AUTH_DATA';
